import React from 'react';
import {Box, MenuItem, TextField} from '@mui/material';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import EditMultiFieldsBuilder from './Shared/EditMultiFieldsBuilder';

const Dropdown = ({
                      index,
                      id,
                      value,
                      onChange,
                      description,
                      isEditMode,
                      enableValidation,
                      options,
                      isFormArchived,
                      relatedComponent
                  }) =>
    <Box>
        {isEditMode
            ? <EditMultiFieldsBuilder onChange={onChange} enableValidation={enableValidation}
                                      description={description} index={index} options={options}
                                      isFormArchived={isFormArchived} optionLengthLimit={180}
                                      relatedComponent={relatedComponent}/>
            : <>
                <Typography>{description}{enableValidation ? '*' : ''}</Typography>
                <Box key={`${description}-${value}`} display={'flex'} justifyContent={'center'}>
                    <TextField
                        select
                        value={value}
                        fullWidth
                        sx={{maxWidth: '650px'}}
                        onChange={e => onChange({id, radioValue: e.target.value})}
                    >
                        {
                            options?.map(option =>
                                <MenuItem key={option.id} value={option.id}>
                                    {option.description}
                                </MenuItem>
                            )
                        }
                    </TextField>
                </Box>
            </>
        }
    </Box>

Dropdown.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    index: PropTypes.number,
    options: PropTypes.array,
    description: PropTypes.string,
    enableValidation: PropTypes.bool,
    onChange: PropTypes.func,
    isEditMode: PropTypes.bool,
    isFormArchived: PropTypes.bool,
    relatedComponent: PropTypes.object,
};

export default Dropdown;